import { createSlice } from '@reduxjs/toolkit';

const authSlice = createSlice({
    name: 'auth',
    initialState: {
        user: null,
        isLoggedIn: false,
        isAuthorized: false,
        loading: true,
    },
    reducers: {
        setUser: (state, action) => {
            state.user = action.payload;
            state.isLoggedIn = !!action.payload;
            state.isAuthorized = action.payload?.isAuthorized || false;
            state.loading = false;
        },
        logout: (state) => {
            state.user = null;
            state.isLoggedIn = false;
            state.isAuthorized = false;
            state.loading = false;
        },
    },
});

export const { setUser, logout } = authSlice.actions;
export default authSlice.reducer;